import { ASSETS } from '../../assetManifest.js';

/**
 * Resolve the icon URL for a given element key using the asset manifest.
 * Falls back to the default icon if the key is not found.
 */
export const iconFor = (key: string): string => {
  const icons = ASSETS.icons || {};
  const avatars = ASSETS.avatars || {};
  
  const maybeIcon = icons[key]?.path;
  if (maybeIcon) return maybeIcon;

  const maybeAvatar = avatars[key]?.path;
  if (maybeAvatar) return maybeAvatar;

  return icons.default?.path || 'assets/default.png';
};

/**
 * Create a custom drag preview element mimicking board tiles.
 * Returns the DOM node; caller is responsible to remove it when finished.
 */
export const createDragPreviewElement = (key: string): HTMLElement => {
  const container = document.createElement('div');
  container.style.width = '72px';
  container.style.height = '72px';
  container.style.borderRadius = '12px';
  container.style.border = '1px solid rgba(255,255,255,0.12)';
  container.style.background = 'rgba(255,255,255,0.05)';
  container.style.backdropFilter = 'blur(2px)';
  container.style.display = 'flex';
  container.style.alignItems = 'center';
  container.style.justifyContent = 'center';
  container.style.boxShadow = '0 8px 18px rgba(0,0,0,0.35)';
  container.style.position = 'fixed';
  container.style.top = '-1000px';
  container.style.left = '-1000px';
  container.style.pointerEvents = 'none';

  const img = document.createElement('img');
  img.src = iconFor(key);
  img.alt = key;
  img.style.width = '64px';
  img.style.height = '64px';
  img.style.objectFit = 'contain';
  img.style.padding = '6px';

  container.appendChild(img);
  document.body.appendChild(container);
  return container;
};
